//@flow
import React, { Component } from 'react';
import btnCss from '../styles/button';
import injectSheet from 'react-jss';

export type ButtonStyleType = "confirm" | "warning" | "cancel";
type Props = {
    type: ButtonStyleType,
    classes: Object,
    buttonText: string,
    disabled: string,
    clickHandler: Function,
    additionalCss: string,
    buttonType: string,
    disabledStyleCss: string
}
class Button extends Component<Props> {

    getButtonClassBasedOnType(type) {
        const { hWarning, hCancel } = this.props.classes;
        if (!type || type === "confirm") {
            return "h-primary-button";
        } else if (type === "warning") {
            return `h-delete-button ${hWarning}`;
        } else if (type === "cancel") {
            return `h-cancel-button`;
        }
        return '';
    }

    render() {
        let { buttonText, clickHandler, additionalCss, disabled, type, buttonType, disabledStyleCss, children, ...other } = this.props;
        const buttonDisabled = disabled ? disabled : false;
        const btnClassBasedOnType = this.getButtonClassBasedOnType(type);
        buttonType = buttonType || 'submit';
        const disabledStyle = { cursor: "not-allowed", pointerEvents: "none" };
        const enabledStyle = { cursor: "pointer" }
        return (
                <button
                    {...other}
                    className={`${btnClassBasedOnType} ${additionalCss} ${buttonDisabled ? disabledStyleCss : '' }`}
                    disabled={buttonDisabled}
                    type={buttonType}
                    style={buttonDisabled ? disabledStyle : enabledStyle }
                    onClick={clickHandler}>
                    {children || buttonText}
                </button>
            );
        }
}

export default injectSheet(btnCss)(Button);
